import { createApi } from '@reduxjs/toolkit/query/react'
import { createBffApiBaseQuery } from './apiClients'

export const paymentOptionsApi = createApi({
    reducerPath: 'paymentOptionsApi',
    baseQuery: createBffApiBaseQuery('paymentOptionsApi', { baseUrl: `${process.env.REACT_APP_API_BASE_URL}/payment-options` }),
    tagTypes: ['PaymentOptions', 'PaymentOptionsByUsername'],
    endpoints: (builder) => ({
        getPaymentOptions: builder.query({
            query: () => {
                return {
                    method: 'GET'
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
            providesTags: ['PaymentOptions']
        }),
        getPaymentOptionsByUsername: builder.query({
            query: (args) => {
                return {
                    url: `/enabled?username=${args.username}`,
                    method: 'GET'
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
            providesTags: ['PaymentOptionsByUsername']
        }),
        updatePaymentOption: builder.mutation({
            query: (body) => {
                return {
                    method: 'PATCH',
                    body: body
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
            invalidatesTags: ['PaymentOptions', 'PaymentOptionsByUsername']
        }),
        generateDonatelloApiKey: builder.mutation({
            query: () => {
                return {
                    url: '/donatello/api-key',
                    method: 'POST'
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
            invalidatesTags: ['PaymentOptions', 'PaymentOptionsByUsername']
        }),
    }),
})

export const { 
    useGetPaymentOptionsQuery,
    useGetPaymentOptionsByUsernameQuery,
    useUpdatePaymentOptionMutation, 
    useGenerateDonatelloApiKeyMutation 
} = paymentOptionsApi
